// import {
//     orderSituation,
//     orderAllocation,
//     orderAssigned,
//     orderCharge,
//     orderDistribution,
//     orderTrend
//   } from '@/apis/workbenchP'
import {
  datasStatistics,
  inspectorFinishingRate,
  inspectorTodaySchedule,
  hiddenStatus,
  hiddenLevel,
  biDatasStatistics
} from '@/apis/securityCheck/billboard'

import { head } from 'lodash'
export default {
  data() {
    return {}
  },
  mounted() {},
  methods: {
    getAllData() {
      // 执行任务的工单完成情况占比
      this.getzxOrderOverview()
      // 执行任务中安检员完成率对比
      this.getfeeSituation()
      // 安检员今日执行进度
      this.getOrderTask()
      // 隐患占比情况
      this.getorderTrend()
      // 隐患占比情况1
      this.getorderTrend1()
    },
    /**
     * 执行任务的工单完成情况占比
     */
    getzxOrderOverview() {
      biDatasStatistics().then(res => {
        if (res.code == 200) {
          // let seriesData = res.data
          let data = res.data
          let [allNumber, rate, ledeng] = [0, 0, []]
          // 百分比四舍五入，前端算，而且必须和必须为100%，如果多或少让未安检加减
          data.forEach(item => {
            allNumber += item.value
            ledeng.push(item.name)
          })

          data.forEach(item => {
            let porop = Number(((item.value / allNumber) * 100).toFixed(2))
            item.proportion = porop
            if (item.name != '未安检') {
              rate += porop
            }
          })
          // for(let i = 0; i < data.length ; i++){
          //   allNumber += data[i]['value']
          //   ledeng.push(data[i]['name'])
          // }
          // for(let i = 0; i < data.length ; i++){
          //   let porop = Number(((data[i]['value'] / allNumber) * 100).toFixed(2))
          //   data[i].proportion = porop
          //   if (data[i]['name'] != '未安检') {
          //     rate += porop
          //   }
          // }
          let optionColorArr = {
            正常入户: '#10D3FF',
            到访不遇: '#76B3FE',
            拒绝安检: '#FE003E',
            停气: '#00DD9C',
            未安检: '#F1AB03'
          }
          rate = rate.toFixed(2)
          console.log(data, rate)
          let option = {
            color: data.map(item => optionColorArr[item.name]),
            tooltip: {
              trigger: 'item',
              show: false
            },
            grid: {
              top: '0',
              left: '0',
              right: '0',
              bottom: '0',
              containLabel: true
            },
            legend: [
              {
                orient: 'vertical',
                top: '22%',
                right: '28%',
                itemWidth: 10,
                itemHeight: 10,
                itemStyle: {
                  borderColor: 'RGBA(255, 255, 255, 0.8)',
                  borderWidth: 4
                },
                textStyle: {
                  height: 10,
                  color: 'auto',
                  fontSize: 14,
                  // padding: [0, 0, 0, 10],
                  rich: {
                    name: {
                      fontSize: 14,

                      color: 'auto',
                      height: 10
                    },
                    value: {
                      fontSize: 14,
                      color: '#000',
                      fontWeight: 800,
                      padding: [10, 0, 0, 0]
                    }
                  }
                },
                formatter: name => {
                  let item = data.filter(item => item.name === name)[0]
                  console.log(item)
                  if (name == '未安检') {
                    return `{name|${name}\n}{value| ${(100 - rate).toFixed(2)}%}`
                  } else {
                    return `{name|${name}\n}{value| ${item.proportion}%}`
                  }
                },
                itemGap: 10,
                data: ledeng.slice(0, 3)
              },
              {
                orient: 'vertical',
                top: '22%',
                right: '8%',
                itemWidth: 10,
                itemHeight: 10,
                itemStyle: {
                  borderColor: 'RGBA(255, 255, 255, 0.8)',
                  borderWidth: 4
                },
                textStyle: {
                  height: 10,
                  color: 'auto',
                  fontSize: 16,
                  // padding: [0, 0, 0, 10],
                  rich: {
                    name: {
                      fontSize: 14,

                      color: 'auto'
                    },
                    value: {
                      fontSize: 14,

                      color: '#000',
                      fontWeight: 800,
                      padding: [10, 0, 0, 0]
                    }
                  }
                },
                formatter: name => {
                  let item = data.filter(item => item.name === name)[0]
                  if (name == '未安检') {
                    return `{name|${name}\n}{value| ${(100 - rate).toFixed(2)}%}`
                  } else {
                    return `{name|${name}\n}{value| ${item.proportion}%}`
                  }
                },
                itemGap: 10,
                data: ledeng.slice(3, 6)
              }
            ],
            series: [
              {
                type: 'pie',
                center: ['28%', '50%'],
                radius: ['46%', '70%'],
                avoidLabelOverlap: false,
                itemStyle: {
                  borderWidth: 2, // 设置边框宽度
                  borderColor: '#ffffff' // 设置边框颜色，与背景色相同即可形成间距效果
                },
                emphasis: {
                  label: {
                    show: true,
                    fontSize: 40,
                    fontWeight: 'bold',
                    formatter: function(data) {
                      if (data.name == '未安检') {
                        return '{b1|' + (100 - rate).toFixed(2) + '%}'
                      } else {
                        return '{b1|' + data.data.proportion + '%}'
                      }
                    },
                    rich: {
                      b1: {
                        color: '#000',
                        fontSize: 18,
                        fontWeight: 800
                      }
                    }
                  }
                },
                label: {
                  show: false,
                  position: 'center'
                },
                labelLine: {
                  show: false
                },
                data: data
              }
            ]
          }

          this.zxOrderOverview.setOption(option, true)
        }
      })
    },
    /**
     * 安检员今日执行进度
     */
    getOrderTask() {
      inspectorTodaySchedule().then(res => {
        if (res.code == 200) {
          let xdata = {
            value: res.data.inspectionNameList
          }
          let sdata = {
            value: res.data.finishingRateList
          }
          let start = res.data.finishingRateList.some(value => Number(value) > 100)
          let option = {
            tooltip: {
              trigger: 'axis',
              formatter: params => {
                let name = params[0].name + '<br/>'
                params.forEach(el => {
                  name +=
                    el.marker +
                    ' 进度' +
                    // el.seriesName +
                    ' <span style="font-weight:bold;">' +
                    (el.value || 0) +
                    '</span>%<br/>'
                })
                return name
              }
            },
            grid: {
              containLabel: true,
              bottom: '5%',
              left: '5%',
              top: '0',
              right: '10%'
            },
            xAxis: {
              type: 'value',
              min: 0,
              max: start ? null : 100,
              interval: start ? null : 20,
              axisLabel: {
                show: true
              },
              axisLine: {
                show: true
              },
              axisTick: {
                show: false
              },
              splitLine: {
                show: true
              }
            },
            yAxis: [
              {
                type: 'category',
                data: xdata.value,
                inverse: true,
                axisLabel: {
                  fontSize: '15px'
                },
                axisLine: {
                  show: false
                },
                axisTick: {
                  show: false
                }
              }
            ],
            series: [
              {
                data: sdata.value,
                type: 'bar',
                barWidth: 15,
                itemStyle: {
                  normal: {
                    label: {
                      show: true,
                      position: 'right',
                      color: '#4874CB',
                      formatter: '{c}' + '%'
                    }
                  }
                }
              }
            ]
          }

          this.orderTask.setOption(option, true)
        }
      })
    },
    /**
     * 执行任务中安检员完成率对比
     */
    getfeeSituation() {
      inspectorFinishingRate().then(res => {
        if (res.code == 200) {
          let data = res.data
          let series = {
            name: '完成率 ',
            data: data.finishingRateList, //数据
            barWidth: 15,
            type: 'bar',
            itemStyle: {
              color: '#91CC75'
            }
          }
          let option = {
            tooltip: {
              //柱状图加阴影
              trigger: 'axis',
              axisPointer: {
                type: 'shadow',
                label: {
                  show: true
                }
              },
              formatter: params => {
                let name = params[0].name + '<br/>'
                params.forEach(el => {
                  name +=
                    el.marker +
                    ' ' +
                    el.seriesName +
                    ' <span style="font-weight:bold;">' +
                    (el.value || 0) +
                    '</span>%<br/>'
                })
                return name
              }
            },
            grid: {
              top: '15%',
              left: '3%',
              right: '3%',
              bottom: '3%',
              containLabel: true
            },
            xAxis: {
              type: 'category',
              data: data.inspectionNameList,
              axisLabel: {
                fontSize: '15px'
              }
            },
            yAxis: {
              name: '%',
              type: 'value',
              min: 0,
              max: 100,
              interval: 20,
              splitLine: {
                show: true,
                lineStyle: {
                  color: '#ccc'
                }
              }
            },
            series: series
          }
          this.feeSituation.setOption(option, true)
        }
      })
    },
    /**
     * 隐患占比情况
     */
    getorderTrend() {
      hiddenStatus().then(res => {
        if (res.code == 200) {
          let seriesData = res.data
          var optionColorArr = {
            未处理: '#EF637A',
            已转维修: '#FFAE27',
            已处理: '#3DA0FD'
          }
          let option = {
            color: seriesData.map(item => optionColorArr[item.name]),
            tooltip: {
              trigger: 'item',
              show: true
            },
            grid: {
              top: '0',
              left: '0',
              right: '0',
              bottom: '0',
              containLabel: true
            },
            legend: {
              type: 'scroll',
              orient: 'vertical',
              left: '65%',
              align: 'left',
              top: 'middle',
              formatter: params => {
                let data = seriesData.find(el => el.name == params)
                return `{a| ${data.name}\n}{b0| ${data.value}}`
              },
              textStyle: {
                height: 13,
                rich: {
                  a: {
                    color: '#8D8D8D',
                    fontSize: 15
                  },
                  b0: {
                    // color: colorList[0],
                    color: '#333',
                    fontSize: 15,
                    fontWeight: 800,
                    padding: [10, 0, 0, 0]
                  }
                }
              }
            },
            series: [
              {
                type: 'pie',
                center: ['35%', '50%'],
                radius: ['50%', '80%'],
                clockwise: true, //饼图的扇区是否是顺时针排布
                avoidLabelOverlap: false,
                label: {
                  show: false
                },
                labelLine: {
                  // 设置标签指示线
                  show: false // 是否显示指示线
                },
                itemStyle: {
                  borderWidth: 5, // 设置边框宽度
                  borderColor: '#ffffff' // 设置边框颜色，与背景色相同即可形成间距效果
                },
                data: seriesData
              }
            ]
          }
          this.orderTrend.setOption(option, true)
        }
      })
    },
    /**
     * 隐患占比情况1
     */
    getorderTrend1() {
      hiddenLevel().then(res => {
        if (res.code == 200) {
          let seriesData = res.data
          var optionColorArr = {
            '1级': '#EF637A',
            '2级': '#FFAE27',
            '3级': '#50CCA7',
            '4级': '#3DA0FD',
            '5级': '#935EE4'
          }
          let option = {
            color: seriesData.map(item => optionColorArr[item.name]),
            tooltip: {
              trigger: 'item',
              show: true
            },
            grid: {
              top: '0',
              left: '0',
              right: '0',
              bottom: '0',
              containLabel: true
            },
            legend: {
              type: 'scroll',
              orient: 'vertical',
              left: '65%',
              align: 'left',
              top: 'middle',
              formatter: params => {
                let data = seriesData.find(el => el.name == params)
                return `{a| ${data.name}}{b0| ${data.value}}`
              },
              textStyle: {
                rich: {
                  a: {
                    color: '#8D8D8D',
                    fontSize: 14
                  },
                  b0: {
                    // color: colorList[0],
                    color: '#333',
                    fontSize: 14,
                    fontWeight: 800,
                    padding: [0, 0, 0, 10]
                  }
                }
              }
            },
            series: [
              {
                type: 'pie',
                center: ['35%', '50%'],
                radius: ['50%', '80%'],
                clockwise: true, //饼图的扇区是否是顺时针排布
                avoidLabelOverlap: false,
                label: {
                  show: false
                },
                labelLine: {
                  // 设置标签指示线
                  show: false // 是否显示指示线
                },
                itemStyle: {
                  borderWidth: 5, // 设置边框宽度
                  borderColor: '#ffffff' // 设置边框颜色，与背景色相同即可形成间距效果
                },
                data: seriesData
              }
            ]
          }
          this.orderTrend1.setOption(option, true)
        }
      })
    }
  }
}
